import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";
import Layout from "../components/Layout";


export const PublicRoute = ({ component: Component, name, ...rest }) => {
  let { loggedIn } = useSelector(({ authentication }) => authentication);

  return (
    <Route {...rest} render={props => {
      if (loggedIn) {
        return <Redirect to="/home"/>;
      }

      return (
        <Layout name={name}>
          <Component {...props} />
        </Layout>
      );
    }} />
  );
};